import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    personal: '',
    fechaSolicitud: '1900-01-01',
    importe: 0,
    observaciones: '',
    usuario: '',

    presupuestosInternos: [],

    solicitudAutorizada: false,
    fechaAutorizacion: '1900-01-01',
    usuarioAutorizacion: '',
    observacionesAutorizacion: '',
    autorizado: false, 

    solicitudRendida: false,
    fechaRendicion: '1900-01-01',
    importeRendicion: 0,
    usuarioRendicion: '',
    observacionesRendicion: '',

    pagos: [],
    rendicionRubros: [],
    comprobantes: [],

    saldoSolicitud: 0
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, viaticoId) {
        state.id = viaticoId;
        state.personal = '';
        state.fechaSolicitud = '1900-01-01';
        state.importe = 0;
        state.observaciones = '';
        state.usuario = '';

        state.presupuestosInternos = [];

        state.solicitudAutorizada = false;
        state.fechaAutorizacion = '1900-01-01';
        state.usuarioAutorizacion = '';
        state.observacionesAutorizacion = '';
        state.autorizado = false; 
    
        state.solicitudRendida = false;
        state.fechaRendicion = '1900-01-01';
        state.importeRendicion = 0;
        state.usuarioRendicion = '';
        state.observacionesRendicion = '';
        
        state.pagos = [];
        state.rendicionRubros = [];
        state.comprobantes = [];

        state.saldoSolicitud = 0;
    },
    'SET_DATOS'(state, viatico) {
        let importeSolicitud = parseFloat(viatico.importe);

        state.personal = viatico.personal.trim();
        state.fechaSolicitud = moment(viatico.fechaSolicitud).format('YYYY-MM-DD');
        state.importe = viatico.importe;
        state.observaciones = viatico.observaciones.trim();
        state.usuario = viatico.usuario.trim();

        state.solicitudAutorizada = moment(viatico.fechaAutorizacion).format('YYYY-MM-DD') != '1900-01-01';
        state.fechaAutorizacion = moment(viatico.fechaAutorizacion).format('YYYY-MM-DD');
        state.usuarioAutorizacion = viatico.usuarioAutorizacion.trim();
        state.observacionesAutorizacion = viatico.observacionesAutorizacion.trim();
        state.autorizado = (/true/i).test(viatico.autorizado);
        
        if (viatico.viaticoPresupuestosInternos) {
            state.presupuestosInternos = viatico.viaticoPresupuestosInternos;
        }
        if (viatico.pagos) {
            state.pagos = viatico.pagos;
        }

        if (viatico.rendicion) {
            importeSolicitud = parseFloat(viatico.rendicion.importe);

            state.solicitudRendida = true;
            state.fechaRendicion = moment(viatico.rendicion.fechaRegistro).format('YYYY-MM-DD');
            state.importeRendicion = viatico.rendicion.importe;
            state.observacionesRendicion = viatico.rendicion.observaciones.trim();
            state.usuarioRendicion = viatico.rendicion.usuario.trim();
        
            if (viatico.rendicion.viaticoRendicionRubros) {
                state.rendicionRubros = viatico.rendicion.viaticoRendicionRubros;
            }
        }

        if (viatico.comprobantes) {
            state.comprobantes = viatico.comprobantes;
        }
        
        /* Calculamos el total de los pagos */
        let totalPagos = state.pagos
            .reduce((total, pago) => total + parseFloat(pago.total), 0);

        state.saldoSolicitud = importeSolicitud - totalPagos;
    },
};

const actions = {
    getDatos ( { commit }, viaticoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', viaticoId);
    
            apiAxios.get('viaticos/' + viaticoId)
                .then(res => {
                    commit('SET_DATOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}